import React from 'react';
import PropTypes from 'prop-types';
import StopStation from '#/shared/components/GeneratedIcons/trimet/StopStation';
import StopStationSolid from '#/shared/components/GeneratedIcons/trimet/StopStationSolid';

function BaseStopStationIcon({ isSolid, ...restProps }) {
  const StationIcon = isSolid === true ? StopStationSolid : StopStation;

  // allow prop spreading since this is a thin wrapper around a set of icons
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <StationIcon {...restProps} />;
}

BaseStopStationIcon.propTypes = {
  isSolid: PropTypes.bool.isRequired,
};

export default BaseStopStationIcon;
